import React from 'react';
import './SupportPage.css';

function PolicyPage() {
    return (
        <div className="App">
            <div className="leftTopBall" />
            <div className="rightTopBall" />
            <div className="leftBottomBall" />
            <div className="rightBottomBall" />
            {/* <div className="centerBall" /> */}
            <h1>Privacy Policy</h1>
            <p><strong>Effective Date:</strong> September 2, 2025</p>

            <section>
                <h2>Introduction</h2>
                <p>Thank you for playing <strong>Flow888</strong>. Your privacy is important to us. This Privacy Policy explains how our game handles your information.</p>
            </section>

            <section>
                <h2>Information We Collect</h2>
                <p><strong>No Personal Data Collected:</strong> Flow888 does not require you to provide any personal information.</p>
                <p><strong>No Accounts or Registration:</strong> You can play the game without creating an account or sharing personal details.</p>
                <p><strong>No Sensitive Data:</strong> We do not collect information such as your name, email address, phone number, or location.</p>
            </section>

            <section>
                <h2>How We Use Information</h2>
                <p>Since Flow888 does not collect personal data, there is no information to store, share, or use.</p>
            </section>

            <section>
                <h2>Third-Party Services</h2>
                <p>Flow888 does not include advertising, analytics, or third-party tracking services.</p>
            </section>

            <section>
                <h2>Children’s Privacy</h2>
                <p>Flow888 is suitable for players of all ages. Since no personal information is collected, the game fully complies with child privacy requirements.</p>
            </section>

            <section>
                <h2>Changes to This Policy</h2>
                <p>We may update this Privacy Policy from time to time. Any changes will be reflected on this page with a new “Effective Date.”</p>
            </section>

            <section>
                <h2>Contact Us</h2>
                <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
                <p>📧 <a href="mailto:winnner62w@gmail.com">winnner62w@gmail.com</a></p>
            </section>

            <footer>
                &copy; 2025 Flow888. All rights reserved.
            </footer>

        </div>
    );
}

export default PolicyPage;
